import { isString } from 'lodash';
import { TFunction } from 'react-i18next';
import { ObjectValues } from 'src/common/tsHelpers';

export const SUBSCRIPTION_STATUS = {
  DEACTIVATED: 0,
  ACTIVE: 1,
  TEST: 2,
  UNKNOWN: 3,
  TERMINATED: 4,
} as const;

export type SubscriptionStatus = ObjectValues<typeof SUBSCRIPTION_STATUS>;

export const getLabelBaseOnSubscriptionStatus = (
  subscriptionStatus: SubscriptionStatus,
  t: TFunction<'translation', undefined>,
): string => {
  switch (subscriptionStatus) {
    case SUBSCRIPTION_STATUS.ACTIVE: {
      return t('simInventory.billingStatuses.active');
    }
    case SUBSCRIPTION_STATUS.DEACTIVATED: {
      return t('simInventory.billingStatuses.deactivated');
    }
    case SUBSCRIPTION_STATUS.TEST: {
      return t('simInventory.billingStatuses.test');
    }
    case SUBSCRIPTION_STATUS.TERMINATED: {
      return t('simInventory.billingStatuses.terminated');
    }
    default: {
      return t('common.unknown');
    }
  }
};
export const parseSubscriptionStatus = (valueToParse: number | string | null) => {
  if (!valueToParse) {
    return SUBSCRIPTION_STATUS.UNKNOWN;
  }
  let numericalValue = valueToParse;
  if (isString(numericalValue)) {
    numericalValue = Number.parseInt(numericalValue);
  }

  if (Number.isNaN(numericalValue)) {
    return SUBSCRIPTION_STATUS.UNKNOWN;
  }

  const validNumericalValues = Object.values(SUBSCRIPTION_STATUS) as number[];
  if (validNumericalValues.includes(numericalValue)) {
    return numericalValue as SubscriptionStatus;
  }

  return SUBSCRIPTION_STATUS.UNKNOWN;
};
